import safeFetch from '../extenstions/safeFetch';
import url from '../extenstions/url';

export default (setSettings) => safeFetch(url.settings)
    .then(setSettings);
